import { createAsyncThunk } from "@reduxjs/toolkit";
import notify from "../../assets/svg/utils/toast/Toast";
import {
  AddenterpriseApi,
  addEnterpriseForStcherApi,
  createAdminUser,
  deleteEnterpriseApi,
  EditenterpriseApi,
  enterpriseApi,
  getOrgAdminList,
  getPreviousLicenseDetails,
  validateEnterpriseKeyApi,
} from "../../services/enterprise/enterprise";

// Add Enterprise API
export const Addenterprise = createAsyncThunk(
  "Addenterprise",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await AddenterpriseApi(data);
      if (response?.status === 201) {
        notify("success", response.data.message);
        dispatch(Getentrprise()); // Fetch updated list after deletion
        return response?.data;
      } else {
        notify("error", response.data.message || "Failed to add enterprise");
        return rejectWithValue("Failed to add enterprise");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);

export const Editenterprise = createAsyncThunk(
  "EditenterpriseApi",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await EditenterpriseApi(data);
      if (response?.status === 200) {
        notify("success", response.data.message);
        dispatch(Getentrprise()); // Fetch updated list after deletion
        return response?.data;
      } else {
        notify("error", response.data.message || "Failed to add enterprise");
        return rejectWithValue("Failed to add enterprise");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);
// Get Enterprise API
export const Getentrprise = createAsyncThunk(
  "Getentrprise",
  async (data, { rejectWithValue }) => {
    try {
      const response = await enterpriseApi({});
      if (response?.status === 200) {
        return response?.data?.data;
      } else {
        notify("error", response.data.message || "Failed to fetch enterprises");
        return rejectWithValue("Failed to fetch enterprises");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);

// Delete Enterprise API
export const deleteEnterprise = createAsyncThunk(
  "deleteEnterprise",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteEnterpriseApi(data);
      if (response?.status === 200) {
        notify(
          "success",
          response?.data.message || "Enterprise deleted successfully"
        );
        dispatch(Getentrprise()); // Fetch updated list after deletion
        return response?.data?.data;
      } else {
        notify("error", response.data.message || "Failed to delete enterprise");
        return rejectWithValue("Failed to delete enterprise");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);
export const validateEnterprisesKey = createAsyncThunk(
  "validateEnterprisesKey",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await validateEnterpriseKeyApi(data);
      if (response?.status === 200) {
        notify(
          "success",
          response?.data.message || "Enterprise key value fetch successfully"
        );
        return response?.data?.data;
      } else {
        notify("error", response.data.message || "Failed to fetch key value");
        return rejectWithValue("Failed to fetch key value");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);
export const previousLicenseDetails = createAsyncThunk(
  "previousLicenseDetails",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await getPreviousLicenseDetails(data);
      if (response?.status === 200) {
        notify(
          "success",
          response?.data.message || "Enterprise value fetch successfully"
        );
        return response?.data?.data;
      } else {
        notify("error", response.data.message || "Failed to fetch  value");
        return rejectWithValue("Failed to fetch  value");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);
export const orgAdminLinks = createAsyncThunk(
  "orgAdminLinks",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await getOrgAdminList(data);
      if (response?.status === 200) {
        notify(
          "success",
          response?.data.message || "Users fetch successfully"
        );
        return response?.data?.data;
      } else {
        notify("error", response.data.message || "Failed to fetch value");
        return rejectWithValue("Failed to fetch value");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);
export const addAdminUser = createAsyncThunk(
  "addAdminUser",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await createAdminUser(data);
      if (response?.status === 200) {
        notify(
          "success",
          response?.data.message || "Users added successfully"
        );
        return response?.data?.data;
      } else {
        notify("error", response.data.message || "Failed to add value");
        return rejectWithValue("Failed to add value");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);


export const AddenterpriseForStcher = createAsyncThunk(
  "AddenterpriseForStcher",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await addEnterpriseForStcherApi(data);
      if (response?.status === 200) {
        notify("success", response.data.message);
        dispatch(Getentrprise()); // Fetch updated list after deletion
        return response?.data;
      } else {
        notify("error", response.data.message || "Failed to add enterprise");
        return rejectWithValue("Failed to add enterprise");
      }
    } catch (error) {
      notify("error", error?.response?.data?.message || "An error occurred");
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);